import { CardType } from '@ui-components/ContentList';
import { iconAngleLeft, iconAngleRight } from '@ui-components/design-tokens';
import { Presentation } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import { ArrowIcon, StyledCustomArrow } from './CarouselArrows.styles';

type Props = {
    carouselId: string;
    presentation: Presentation;
    cardType: CardType;
};

export enum ARROW_DIRECTION {
    LEFT = 'LEFT',
    RIGTH = 'RIGHT',
}

const CarouselArrows = ({ carouselId, presentation, cardType }: Props): JSX.Element => (
    <div>
        <StyledCustomArrow
            type="button"
            aria-label="Gå bakåt i lista"
            aria-hidden
            // @ts-ignore
            htmlFor={carouselId}
            value="left"
            direction={ARROW_DIRECTION.LEFT}
            presentation={presentation}
            cardType={cardType}
            disabled
            tabIndex={-1}
        >
            <ArrowIcon icon={iconAngleLeft} />
        </StyledCustomArrow>

        <StyledCustomArrow
            type="button"
            aria-label="Gå framåt i lista"
            aria-hidden
            // @ts-ignore
            htmlFor={carouselId}
            value="right"
            direction={ARROW_DIRECTION.RIGTH}
            presentation={presentation}
            cardType={cardType}
            tabIndex={-1}
        >
            <ArrowIcon icon={iconAngleRight} />
        </StyledCustomArrow>
    </div>
);

export default CarouselArrows;
